import { arraysEqual } from '../../../utilities'

export const ALL_COLUMNS = {
  title: 'Title',
  due_date: 'Due Date',
  status: 'Status',
  type: 'Type',
  updated_at: 'Updated At',
  assignee_ids: 'Assignees',
  watcher_ids: 'Watchers',
  priority: 'Priority',
  category_id: 'Category',
  concerning_user_id: 'Client',
  created_by: 'Author',
  created_at: 'Created',
  owner_id: 'Owner',
  primary_assignee_id: 'Task Lead',
  tags: 'Tags'
}

export const COLUMN_KEYS: Record<string, string> = Object.keys(
  ALL_COLUMNS
).reduce((acc, curr) => {
  // @ts-ignore
  acc[[curr]] = curr
  return acc
}, {})

const DEFAULT_KEYS = [
  'title',
  'due_date',
  'status',
  'type',
  'updated_at',
  'assignee_ids',
  'category_id'
]

const CODED_DEFAULTS = {
  'Assigned to me': ['title', 'due_date', 'status'],
  'Assigned to others': ['title', 'due_date', 'status', 'assignee_ids'],
  'My own tasks': ['title', 'due_date', 'status']
}

const ORDER_KEY = 'TASK_COLUMN_ORDER'
const VISIBILITY_KEY = 'TASK_COLUMN_VISIBILITY'

// Gets default column values
const getDefaultColumns = key => {
  if (key in CODED_DEFAULTS) {
    return CODED_DEFAULTS[key]
  }

  return DEFAULT_KEYS
}

// Formats storage key based off incoming keys
const constructStorageKey = (base, key) => `${base}:${key}`

// Adds an item to storage if possible
const save = (base, key, data) => {
  try {
    const storageKey = constructStorageKey(base, key)
    localStorage.setItem(storageKey, JSON.stringify(data))
  } catch (err) {
    console.error('Failed saving column settings', err)
  }
}

// Removes an item from storage
const remove = (base, key) => {
  const storageKey = constructStorageKey(base, key)
  localStorage.removeItem(storageKey)
}

// Updates storage based on values
export const checkCache = (key, order, visible) => {
  const defaults = getDefaultColumns(key)

  // Free space if back to defaults, save otherwise
  if (arraysEqual(order, defaults, true)) {
    remove(ORDER_KEY, key)
  } else {
    save(ORDER_KEY, key, order)
  }

  // Free space if back to defaults, save otherwise
  if (arraysEqual(visible, defaults)) {
    remove(VISIBILITY_KEY, key)
  } else {
    save(VISIBILITY_KEY, key, visible)
  }
}

const loadData = (base, key) => {
  const storageKey = constructStorageKey(base, key)
  const data = localStorage.getItem(storageKey)
  if (data) {
    return JSON.parse(data)
  }

  return getDefaultColumns(key)
}

export const loadSettings = key => {
  const order = loadData(ORDER_KEY, key)
  const visible = loadData(VISIBILITY_KEY, key)

  return {
    order,
    visible
  }
}
